import { BaseComponent } from '../../base-component';
import { addEventMergeIdIfVariationChangedAndExists } from '../../_common/client/tracking';
import { waitForCondition } from '../../_common/client/wait-for-condition';

export class RecoAddOnSalesComponent extends BaseComponent {
    public rootSelector = '.js_pdp_reco-add-on-sales';
    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }

        const rootElement = this.getRootElement();
        const variationId = rootElement.dataset.variationId;

        if (!variationId) {
            return;
        }
        waitForCondition(() => !!o_reco?.api?.loadRecommendationsForAddOnSales).then(() => {
            o_reco?.api.loadRecommendationsForAddOnSales(
                addEventMergeIdIfVariationChangedAndExists({ target: rootElement, variationId: variationId })
            );
        });
    }
}
